<template>
    <div>
        <vue-element-loading :active="isLoading" is-full-screen text="Please wait..." />
        <component :is="this.headerFooter.header"></component>
        <div class="container">
            <div style="margin-top:100px;">
                <p class="page-title">帳號管理</p>
                <b-form inline>
                    <b-button v-b-modal.modal-1 variant="outline-secondary">建立帳號</b-button>
                    <b-form-input
                        id="inline-form-input-name"
                        class="mb-2 mr-sm-2 mb-sm-0"
                        placeholder="帳號或姓名"
                        style="margin-left:20px;"
                        v-model="searchTxt"
                    ></b-form-input>

                    <b-button variant="outline-secondary" @click="searchAccount">搜尋</b-button>
                    <b-button variant="outline-secondary" style="margin-left:20px;" @click="getAccountInfo('0')">顯示所有帳號</b-button>
                </b-form>
                <table class="table table-hover" id="_appendHere" style="text-align:center;margin-top:20px;">
                    <thead>
                        <tr>
                            <th scope="col" style="text-align:center;">姓名</th>
                            <th scope="col" style="text-align:center;">帳號</th>
                            <th scope="col" style="text-align:center;">帳號狀態</th>
                            <th scope="col" style="text-align:center;">建立時間</th>
                            <th scope="col" style="text-align:center;">更多操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in accountInfo" :key="index">
                            <td>{{item.doc_name}}</td>
                            <td>{{item.doc_account}}</td>
                            <td v-if="item.status == '1'">啟用</td>
                            <td v-else-if="item.status == '0'">停用</td>
                            <td>{{item.datetime}}</td>
                            <td>
                                <b-button variant="outline-secondary" @click="moreActions(item.doc_account,item.status)">操作</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="overflow-auto">
                    <div>
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @click.native="getCurrentPage(currentPage)" align="center"></b-pagination>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="modal-1" title="建立帳號" centered>
            <b-form inline>
                <b-form-input
                    id="inline-form-input-name"
                    class="mb-2 mr-sm-2 mb-sm-0"
                    placeholder="姓名"
                    style="margin-left:20px;"
                    v-model="name"
                ></b-form-input>
            </b-form>
            <b-form inline style="margin-top:10px;">
                <b-form-input
                    id="inline-form-input-name"
                    class="mb-2 mr-sm-2 mb-sm-0"
                    placeholder="帳號"
                    style="margin-left:20px;"
                    v-model="account"
                ></b-form-input>

                <b-button variant="outline-secondary" @click="generateCode('0')">隨機產生帳號</b-button>
            </b-form>
            <b-form inline style="margin-top:10px;">
                <b-form-input
                    id="inline-form-input-name"
                    class="mb-2 mr-sm-2 mb-sm-0"
                    placeholder="密碼"
                    style="margin-left:20px;"
                    v-model="password"
                ></b-form-input>

                <b-button variant="outline-secondary" @click="generateCode('1')">隨機產生密碼</b-button>
            </b-form>
            <b-form inline style="margin-top:10px;">
                <b-form-group label="帳號狀態" v-slot="{ ariaDescribedby }" style="margin-left:20px;">
                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="1">啟用</b-form-radio>
                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="0">停用</b-form-radio>
                </b-form-group>
            </b-form>
            <template #modal-footer>
                 <b-button  variant="secondary">
                    取消
                </b-button>
                <b-button  variant="success" @click="createAccount">
                    建立
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-2" title="帳號&密碼" centered>
            <div class="d-block color-red">密碼只會顯示一次請妥善保存帳號和密碼</div>
            <b-form inline style="margin-top:20px;">
                <div id="account">帳號: {{ account }}</div>
                <b-button variant="link" @click="copyAccountTxt(account)">複製</b-button>
            </b-form>
            <b-form inline style="margin-top:10px;">
                <div id="password">密碼: {{ password }}</div>
                <b-button variant="link" @click="copyPasswordTxt(password)">複製</b-button>
            </b-form>
        </b-modal>
        <b-modal id="modal-3" title="更多操作" centered>
            <b-form inline style="margin-top:20px;">
                <b-form-input
                    id="inline-form-input-name"
                    class="mb-2 mr-sm-2 mb-sm-0"
                    placeholder="新密碼"
                    style="margin-left:20px;"
                    v-model="doc_password"
                ></b-form-input>

                <b-button variant="outline-secondary" @click="changeAccountPassword">修改密碼</b-button>
            </b-form>
            <b-form inline style="margin-top:10px;">
               <b-form-group label="帳號狀態" v-slot="{ ariaDescribedby }" style="margin-left:20px;">
                    <b-form-radio v-model="accountStatus" :aria-describedby="ariaDescribedby" name="some-radios" value="1">啟用</b-form-radio>
                    <b-form-radio v-model="accountStatus" :aria-describedby="ariaDescribedby" name="some-radios" value="0">停用</b-form-radio>
                    <b-button size="sm" variant="outline-secondary" style="margin-top:5px;" @click="changeAccountStatus">更改狀態</b-button>
                </b-form-group>
            </b-form>
            <template #modal-footer>
                 <b-button  variant="secondary" @click="closemodal">
                    關閉
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import store from "@/store"
export default {
    data() {
        return {
            searchTxt: '',
            doc_account: '',
            doc_password: '',
            account: '',
            password: '',
            name: '',
            setPage: 0,
            totlePage: 0,
            currentPage: 1,
            perPage: 20,
            accountInfo: [],
            selected: '1',
            accountStatus: '1',
            getType: '0',
            isLoading: false,
        }
    },
    components: {
        Header,
    },
    created(){
        const user = JSON.parse(sessionStorage.getItem('my_info'));
        if(user === null){
            alert("请重新登入");
            this.$router.push('/login');
        }else{
            this.getAccountInfo(this.getType);
        }
    },
    computed: {
        headerFooter() {
            return store.getters['auth/isLoggedIn'] ? {
                header: Header,
            } : {
                header: Header,
            }
        },
        rows() {
            return this.totlePage
        },
    },
    methods: {
        createAccount() {
            this.isLoading = true;
            const api = `${process.env.VUE_APP_APIPATH}/register/login`;
            const json = {
                account: this.account,
                password: this.password,
                name: this.name,
                status: this.selected
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    alert("建立成功");
                    this.getAccountInfo(this.getType);
                    this.$nextTick(() => {
                        this.$bvModal.hide('modal-1');
                    })
                    this.$root.$emit('bv::show::modal', 'modal-2');
                }else{
                    alert(res.data.info);
                }
                this.isLoading = false;
            })
        },
        getAccountInfo(type) {
            this.isLoading = true;
            const api = `${process.env.VUE_APP_APIPATH}/doc/account/info`;
            const json = {
                setPage: this.setPage,
                limit: 10,
                search: this.searchTxt,
                getType: type
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.accountInfo = res.data.data;
                    this.getAllClientCount();
                }else{
                    alert("尚無資料");
                }
                this.isLoading = false;
            })
        },
        getAllClientCount() {
            const api = `${process.env.VUE_APP_APIPATH}/doc/account/count`;
            this.$http.get(api).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.totlePage = res.data.data[0].num;
                }
                this.isLoading = false;
            })
        },
        changeAccountStatus() {
            this.isLoading = true;
            const api = `${process.env.VUE_APP_APIPATH}/change/doc/account/status`;
            const json = {
                account: this.doc_account,
                status: this.accountStatus
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    alert("更新成功")
                    this.getAccountInfo(this.getType);
                }
                this.isLoading = false;
            })
        },
        changeAccountPassword() {
            this.isLoading = true;
            const api = `${process.env.VUE_APP_APIPATH}/change/doc/account/password`;
            const json = {
                account: this.doc_account,
                password: this.doc_password
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    alert("更新成功")
                }
                this.isLoading = false;
            })
        },
        searchAccount() {
            this.currentPage = 1;
            this.getType = '1';
            if(this.searchTxt !== ''){
                this.getAccountInfo(this.getType);
            }
        },
        moreActions(doc_account,status) {
            this.doc_account = doc_account
            this.accountStatus = status
            this.$root.$emit('bv::show::modal', 'modal-3');
        },
        getCurrentPage(currentPage) {
            if(currentPage == 1) {
                this.setPage = 0;
            }else {
                this.setPage = 20 * (currentPage - 1);
            }
            this.getAccountInfo(this.getType);
        },
        copyAccountTxt(text) {
            navigator.clipboard.writeText(text)
            .then(() => {
                alert("複製成功")
            })
        },
        copyPasswordTxt(text) {
            navigator.clipboard.writeText(text)
            .then(() => {
                alert("複製成功")
            })
        },
        closemodal() {
            this.$nextTick(() => {
                this.$bvModal.hide('modal-3');
            })
        },
        generateCode(type) {
            const strLen = 10;
            var strArr = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','0','1','2','3','4','5','6','7','8','9'];
            var strword = '';
            var strArrLen = strArr.length;
            for (var i=0; i<strLen; i++){
                var x = Math.floor(Math.random()*strArrLen);
                strword += strArr[x];
            }
            if(type == '0'){
                this.account = strword;
            }else{
                this.password = strword;
            } 
        }
    }
}
</script>